import { Table } from "antd"
import { theme, styled, css } from "twin.macro"
import { cssBaseAntPagination, cssBaseAntTable } from "@/styles/css"

export const dynamicStyles = ({
    striped,
    stripeRowReverse,
    rowHoverHighlight,
    onRow,
    rowSelection
}) => {
    let styles = css``
    if (striped) {
        styles = stripeRowReverse
            ? css`
                  ${styles}
                  &.ant-table-wrapper:not(.atomic-loading-table)
                .ant-table-tbody
                .ant-table-row:nth-of-type(even)
                .ant-table-cell {
                      background: ${theme`colors.lightgray200`};
                  }
              `
            : css`
                  ${styles}
                  &.ant-table-wrapper:not(.atomic-loading-table)
                .ant-table-tbody
                .ant-table-row:nth-of-type(odd)
                .ant-table-cell {
                      background: ${theme`colors.lightgray200`};
                  }
              `
    }

    if (rowHoverHighlight) {
        let isRowClickable = typeof onRow === "function"
        isRowClickable ||= typeof rowSelection?.onChange === "function"

        styles = css`
            ${styles}
            &.ant-table-wrapper:not(.atomic-loading-table)
                .ant-table-tbody
                .ant-table-row:hover
                .ant-table-cell {
                background-color: ${theme`colors.gray200`};
                cursor: ${isRowClickable ? "pointer" : "default"};
                &:first-of-type::before {
                    content: "";
                    position: absolute;
                    width: 2px;
                    height: calc(100% + 2px);
                    background-color: ${theme`colors.primary`};
                    top: -1px;
                    left: 0;
                }
            }
        `
    }
    return styles
}

export const StyledTable = styled(Table)`
    &.ant-table-wrapper .ant-table-cell {
        padding: 8px;

        &.ant-table-selection-column {
            padding-right: 0;
        }
    }

    &.ant-table-wrapper .ant-table-thead .ant-table-column-has-sorters::before {
        display: none;
    }

    &.ant-table-wrapper .ant-table-thead .ant-table-column-title {
        ${theme`typo.mregular`}
    }

    &.ant-table-wrapper .ant-table-thead .ant-table-cell {
        background: ${theme`colors.gray200`};
        font-weight: normal;
    }

    &.ant-table-wrapper .ant-table-thead .ant-table-column-has-sorters:hover {
        background: ${theme`colors.gray300`};
    }

    &.atomic-empty-table .ant-table-placeholder td {
        border-bottom: none;
    }

    ${cssBaseAntTable}
    ${dynamicStyles}

    &.ant-table-wrapper:not(.atomic-loading-table) .ant-table-row {
        &.ant-table-row-selected .ant-table-cell {
            background-color: ${theme`colors.navyblue200`} !important;
        }

        &.ant-table-row-selected:not(.row-disabled):hover .ant-table-cell {
            background-color: ${theme`colors.navyblue300`} !important;
        }

        &.row-disabled .ant-table-cell {
            cursor: not-allowed !important;
            color: ${theme`colors.text_disable`};
        }
    }

    .ant-pagination {
        ${cssBaseAntPagination}
    }

    .row-inactive {
        .ant-table-cell {
            color: ${theme`colors.gray400`};
        }
    }
`
